export default __webpack_public_path__ + "static/media/maths-bg.006f05c6.webp";